import { OrganizationApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch, RootState } from '../../../store';
import { setActiveSubscription as setActiveSubscriptionAction } from '../../../store/slices/active-subscription.slice';
import { LocalStorage, ACCESS_TOKEN } from '../../../util/LocalStorage';
import { selectUserSub } from '../../../store/slices/auth.slice';
import { ErrorCodes } from '../../../api/utils/errorCodes';

const useHttpGetActiveSubscriptionOnMount = () => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const dispatch = useAppDispatch();
    const storage: LocalStorage = useContainer(LocalStorage);
    const userSub = useSelector<RootState, string>(selectUserSub);

    useEffect(() => {
        const accessToken = storage.get(ACCESS_TOKEN);

        if (!userSub || !accessToken) {
            return;
        }

        const { exec, abort } = organizationApi.getActiveSubscription({
            skipAuthErrorHandling: true,
            onSuccess: res => {
                dispatch(setActiveSubscriptionAction(res.body));
            },
            onError: (error, statusCode) => {
                if (
                    statusCode === 401 ||
                    (typeof error !== 'string' && (error?.errorCode === ErrorCodes.HTTP_401 || error?.errorCode === ErrorCodes.UNAUTHORIZED))
                ) {
                    dispatch(setActiveSubscriptionAction(null));
                    return;
                }
            },
        });

        exec();
        return abort;
    }, [userSub]);
};

export default useHttpGetActiveSubscriptionOnMount;
